module.exports = __webpack_public_path__ + "static/media/599.705493(10).653bc243.pdf";